import { getAppEnv } from '@/utils/env'
import { initNoticeNews } from './components/noticeNews'
import { initGlobalNav } from './components/globalNav'
import { initLeftNav } from './components/leftNav'
import { initBreadcrumb } from './components/breadcrumb'
import { initSmoothScroll } from './components/smoothScroll'
import { initScrollController } from './components/scrollController'
import { initSnsComponents } from './components/sns'
import { setLegacyGlobals } from './legacyGlobals'

// MEMO: 旧 JS は common.js の直後に読み込まれ、トップレベルでグローバル変数を参照するため、DOMContentLoaded を待たずに設定する
setLegacyGlobals()

/**
 * 共通コンポーネントの初期化
 */
const init = (): void => {
    const env = getAppEnv()

    initNoticeNews()
    initGlobalNav()
    initLeftNav(env)
    initBreadcrumb()
    initSmoothScroll()
    initScrollController(env)
    initSnsComponents()
}

if(document.readyState==='loading') {
    document.addEventListener('DOMContentLoaded', init)
}
else {
    init()
}
